var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGroup = function SvgGroup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-4 -4 26 26"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#6CB5FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.198 8.2q.002.564.002 1.2c0 3.582 0 5.374-1.113 6.487S12.183 17 8.6 17c-3.582 0-5.374 0-6.487-1.113S1 12.983 1 9.4c0-3.582 0-5.374 1.113-6.487S5.017 1.8 8.6 1.8q.636 0 1.2.002"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 16.6c3.498-4.18 7.42-9.693 13.198-5.966M14.2 1l.206.558c.27.73.406 1.096.672 1.363.268.267.633.402 1.364.673L17 3.8l-.558.206c-.73.27-1.096.406-1.363.672-.267.268-.402.633-.673 1.364L14.2 6.6l-.206-.558c-.27-.73-.406-1.096-.672-1.363-.268-.267-.633-.402-1.364-.673L11.4 3.8l.558-.206c.73-.27 1.096-.406 1.363-.672.267-.268.402-.633.673-1.364z"
  }))));
};
export default SvgGroup;